/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import TextField, {Props} from '../textfield/TextField';

const styleOverrides = () => ({
  root : {
    '& input' : {
      height : '35px'
    }
  },
  inputRoot : {
    '& input' : {
      height      : '35px',
      paddingLeft : '11px'
    }
  }
});

/**
 * @FormTextField
 * Component that wraps the TextField with styles that are specific to the
 * a Form.
 *
 * @param {object} props pass through props that get sent to TextField
 *
 * ```typescript
 *
 * import {FormTextField} from '@ion/dls/src/components/forms/FormTextField';
 *
 * <FormTextField {...props} />
 *
 * ```
 */
export const FormTextField = (props: Props) => (
  <TextField styleOverrides={props.styleOverrides || styleOverrides}
    inputProps={{
      maxLength : props?.maxLength,
      ...props.inputProps
    }} {...props} />
);

export default FormTextField;
